import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/show_toast"

// Shows a single toast from data attributes and cancels the default click action.
//
// Used when navigation would be wrong — e.g. the thing-show "claim this listing"
// link when the account already has an open claim. preventDefault keeps the user
// on the page so Turbo does not round-trip and drop a flash toast.
//
// Flash-on-load stays in flash_toast_controller; Turbo Stream toasts use the custom
// "toast" stream action.
export default class extends Controller {
  static values = {
    message: String,
    theme: { type: String, default: "error" },
    duration: { type: Number, default: 4000 }
  }

  show(event) {
    event.preventDefault()
    if (!this.messageValue) return

    const options = this.hasDurationValue && this.durationValue > 0
      ? { duration: this.durationValue }
      : {}
    showToast(this.messageValue, this.themeValue, options)
  }
}
